export default "__VITE_ASSET__DXdQBlSh__"